import { render } from "./smsComponent.vue?vue&type=template&id=c2d2d638&scoped=true"
import script from "./smsComponent.vue?vue&type=script&lang=js"
export * from "./smsComponent.vue?vue&type=script&lang=js"

import "./smsComponent.vue?vue&type=style&index=0&id=c2d2d638&scoped=true&lang=css"
import "./smsComponent.vue?vue&type=style&index=1&id=c2d2d638&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d2d638"]])

export default __exports__